import { render, staticRenderFns } from "./AccountRequested.vue?vue&type=template&id=2b6c3df3&"
import script from "./AccountRequested.vue?vue&type=script&lang=js&"
export * from "./AccountRequested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports